// Dependencies
import {
  CHANGE_QTY_LABEL,
  RESET_QTY_LABEL,
  RESET_QTY_LABEL_ALL,
} from "./types";

const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_QTY_LABEL:
      return { ...state, [action.payload.idCompra]: action.payload.value };
    case RESET_QTY_LABEL:
      return { ...state, [action.payload]: "" };
    case RESET_QTY_LABEL_ALL:
      return initialState;
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
